export type DeviceType = 'mobile' | 'tablet' | 'desktop';

const TABLET_MAX_WIDTH = 1024;
const MOBILE_MAX_WIDTH = 768;

export function getDeviceType(): DeviceType {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return 'desktop';
  }

  const ua = navigator.userAgent || '';

  const isIPad = /iPad/i.test(ua) || (/Macintosh/i.test(ua) && 'ontouchend' in document);
  const isAndroidTablet = /Android/i.test(ua) && !/Mobile/i.test(ua);
  if (isIPad || isAndroidTablet) {
    return 'tablet';
  }

  const mobileRegex = /Mobile|iPhone|iPod|Android.*Mobile|BlackBerry|IEMobile|Opera Mini|webOS/i;
  if (mobileRegex.test(ua)) {
    return 'mobile';
  }

  const width = window.innerWidth || 0;
  if (width > 0 && width <= MOBILE_MAX_WIDTH) {
    return 'mobile';
  }
  if (width > 0 && width <= TABLET_MAX_WIDTH) {
    return 'tablet';
  }

  return 'desktop';
}
